import axios from '@/libs/api.request'

const shopSalesDetail = {
    // 营业额，客单价，报废
    getShopSalesDetail: (data) => {
        return axios.post({
            url: '/ShopSalesDetail',
            data: data
        })
    },
    // 充值
    getShopSalesRecharge: (data) => {
        return axios.post({
            url: '/ShopSalesDetail/Recharge',
            data: data
        })
    },
    // 营业额构成
    getShopSalesPayDetail: (data) => {
        return axios.post({
            url: '/ShopSalesDetail/PayDetail',
            data: data
        })
    },
    // 门店一览
    getShopSalesAllShop: (data) => {
        return axios.post({
            url: '/ShopSalesDetail/AllShop',
            data: data
        })
    },
    // 查看或编辑初始化
    editOrGetInitAssistant: (data) => {
        return axios.post({
            url: '/User/editOrGetInitAssistant',
            data: data
        })
    },
}
export default shopSalesDetail


// WEBPACK FOOTER //
// ./src/api/api-shopSalesDetail.js